import { ColumnsType } from "antd/es/table";
import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import { shortenString } from "@lib/helpers/StringHelper";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import { MessageFormatElement } from "react-intl";
import {
  TransactionProxyState,
  TransactionProxyStatus,
  TransactionType,
} from "@lib/types/Transaction";
import {
  CoinPriceTextFormat,
  PaymentHistoryState,
  PaymentHistoryStatus,
} from "@lib/components/MiniComponents/Others";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";

type Props<T> = {
  apiData?: T[];
  messages: Record<string, string> | Record<string, MessageFormatElement[]>;
  handleSelect: (transaction: T) => void;
};

const getColumns = <T extends TransactionType>(
  props: Props<T>,
): ColumnsType<T> => {
  const { messages } = props;

  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "External ID",
      dataIndex: "externalId",
      render: (v, r) => (
        <TableIdButton
          // link={`/payment_history/list/${r.id}`}
          text={`#${shortenString(r.externalId, 8)}`}
          textToBeCopied={r.externalId}
          style={{ fontSize: 12 }}
        />
      ),
      filterType: "search",
      width: "150px",
    },
    {
      title: "common.amount",
      dataIndex: "amount",
      key: "amount",
      width: "150px",
      render: (value, r) => (
        <CoinPriceTextFormat
          amount={value}
          showCurrency={r?.currency}
          align="left"
        />
      ),
    },
    {
      title: "common.status",
      dataIndex: "status",
      key: "status",
      width: "150px",
      render: (status) => <PaymentHistoryStatus status={status} />,
      filters: Object.values(TransactionProxyStatus).map((status) => ({
        text:
          (messages["enums.transactionProxyStatus"][status] as string) ||
          status ||
          " - ",
        value: status,
      })),
      filterType: "dropdown",
    },
    {
      title: "common.state",
      dataIndex: "state",
      key: "state",
      width: "200px",
      render: (state) => <PaymentHistoryState state={state} />,
      filters: Object.values(TransactionProxyState).map((state) => ({
        text:
          (messages["enums.transactionProxyState"][state] as string) ||
          state ||
          " - ",
        value: state,
      })),
      filterType: "dropdown",
    },
    {
      title: "common.updatedAt",
      dataIndex: "updatedAt",
    },
    {
      title: "common.createdAt",
      dataIndex: "createdAt",
    },
    {
      title: "#",
      dataIndex: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "40px",
      render: (_, record) => (
        <StyledFlex className="actions">
          <ActionButton
            type="detail"
            onClick={() => props.handleSelect(record)}
            noLabel
          />
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};

export default getColumns;
